<template>
  <RouterLink :to="menu.route">
    <div
      class="w-full rounded overflow-hidden relative"
      @mouseenter="active = true"
      @mouseleave="active = false"
    >
      <div
        class="absolute w-full z-10 backdrop-blur-md flex items-center justify-center text-white bottom-0 py-2 md:(items-start px-3 py-5 flex-col gap-3 justify-between transition ease-in-out delay-150 duration-800 -bottom-16)"
        :class="{'!-translate-y-15': active && $q.screen.gt.sm}"
      >
        <div class="flex flex-col gap-2">
          <div class="text-2xl font-bold flex items-center gap-1">
            <ImgIcon
              :src="menu.icon"
              size="22px"
            />{{ menu.title }}
          </div>
          <div
            v-if="$q.screen.gt.sm"
            class="text-sm h-10"
          >
            {{ menu.content }}
          </div>
        </div>
        <QBtn
          v-if="$q.screen.gt.sm"
          unelevated
          :label="menu.label"
          class="h-10 w-full !bg-gradient-to-tr"
          :class="`${menu.color}`"
        />
      </div>
      <QImg
        :src="menu.img"
        alt=""
        class="z-1"
        :class="{'delay-150 duration-500 ease-in-out scale-110': active && $q.screen.gt.sm}"
      />
    </div>
  </RouterLink>
</template>

<script setup>
import {ref} from 'vue'
import ImgIcon from '@/components/Icons/ImgIcon.vue'

defineProps({
  menu: {
    type: Object,
    default: () => ({})
  }
})

const active = ref(false)
</script>
<style scoped>
::v-deep(.twinkle) {
  animation: twinkle 1s linear infinite
}

@keyframes twinkle {
  0% {
    @apply border-deep-2
  }
  50% {
    @apply border-primary
  }
  100% {
    @apply border-deep-2
  }
}
</style>